import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  horseshoeButton: {
    display: "flex",
    placeItems: "center",
    height: 25,
    padding: 0,
    width: 25
  },
  horseShoe: {
    fill: theme.palette.warning.dark,
    width: 17
  },
  listsModal: {
    "& .MuiDialogTitle-root": {
      minWidth: 256,
      paddingRight: 45,
      maxWidth: 370
    },
    "& .MuiDialogContent-root": {
      padding: 0
    }
  },
  modalTitleClassName: {
    fontWeight: 700,
    [theme.breakpoints.down("xs")]: {
      fontSize: "1rem"
    }
  },
  detailsDialogText: {
    margin: "13px 0 13px 21px",
    fontSize: 15
  },
  detailsDialogDate: {
    marginLeft: 16
  },
  activityLine: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "#f6f6f6",
    height: 48,
    padding: "0 26px",
    borderTop: "solid 1px #eee",
    "&:nth-child(odd)": {
      backgroundColor: "#fff"
    }
  }
}));
